module.exports = __webpack_public_path__ + "img/facebook.03d1d295.svg";